import { postRequest } from '@/libs/axios'

// 邮编分页查询（按分组）
export const pagePostalCode = (params) => {
  return postRequest('/ndt/postalCode/page', params)
}

// 新增邮编
export const createPostalCode = (params) => {
  return postRequest('/ndt/postalCode/create', params)
}

// 更新邮编
export const updatePostalCode = (params) => {
  return postRequest('/ndt/postalCode/update', params)
}